import { render } from "./TestimonioSushiRollNew.vue?vue&type=template&id=75221dc6&scoped=true"
import script from "./TestimonioSushiRollNew.vue?vue&type=script&lang=js"
export * from "./TestimonioSushiRollNew.vue?vue&type=script&lang=js"

import "./TestimonioSushiRollNew.vue?vue&type=style&index=0&id=75221dc6&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75221dc6"]])

export default __exports__